"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variants = void 0;
var createTheme_1 = __importDefault(require("@material-ui/core/styles/createTheme"));
var breakpoints_1 = require("./theme/global/breakpoints");
var palette_1 = require("./theme/global/palette");
var shape_1 = require("./theme/global/shape");
var typography_1 = require("./theme/global/typography");
// Style Overrides
var accordion_1 = require("./theme/components/accordion/accordion");
var accordionDetails_1 = require("./theme/components/accordionDetails/accordionDetails");
var accordionSummary_1 = require("./theme/components/accordionSummary/accordionSummary");
var alert_1 = require("./theme/components/alert/alert");
var backdrop_1 = require("./theme/components/backdrop/backdrop");
var Badge_1 = require("./theme/components/Badge/Badge");
var breadcrumbs_1 = require("./theme/components/breadcrumbs/breadcrumbs");
var button_1 = require("./theme/components/button/button");
var Card_1 = require("./theme/components/card/Card");
var CardContent_1 = require("./theme/components/cardContent/CardContent");
var checkbox_1 = require("./theme/components/checkbox/checkbox");
var chip_1 = require("./theme/components/chip/chip");
var baseLine_1 = require("./theme/global/baseLine");
var dialogActions_1 = require("./theme/components/DialogActions/dialogActions");
var dialogContent_1 = require("./theme/components/DialogContent/dialogContent");
var dialogContectText_1 = require("./theme/components/DialogContentText/dialogContectText");
var dialogTitle_1 = require("./theme/components/DialogTitle/dialogTitle");
var floatingActionButton_1 = require("./theme/components/floatingActionButton/floatingActionButton");
var formControl_1 = require("./theme/components/formControl/formControl");
var formControlLabel_1 = require("./theme/components/formControlLabel/formControlLabel");
var formHelperText_1 = require("./theme/components/formHelperText/formHelperText");
var formLabel_1 = require("./theme/components/formLabel/formLabel");
var iconButton_1 = require("./theme/components/iconButton/iconButton");
var inputAdornment_1 = require("./theme/components/inputAdornment/inputAdornment");
var inputBase_1 = require("./theme/components/inputBase/inputBase");
var inputLabel_1 = require("./theme/components/inputLabel/inputLabel");
var linearProgress_1 = require("./theme/components/linearProgress/linearProgress");
var link_1 = require("./theme/components/link/link");
var listItem_1 = require("./theme/components/listItem/listItem");
var menu_1 = require("./theme/components/menu/menu");
var menuItem_1 = require("./theme/components/menuItem/menuItem");
var mobileStepper_1 = require("./theme/components/mobileStepper/mobileStepper");
var outlinedInput_1 = require("./theme/components/outlinedInput/outlinedInput");
var pickers_1 = require("./theme/components/pickers/pickers");
var popover_1 = require("./theme/components/popover/popover");
var radio_1 = require("./theme/components/radio/radio");
var paginationItem_1 = require("./theme/components/paginationItem/paginationItem");
var select_1 = require("./theme/components/select/select");
var slider_1 = require("./theme/components/slider/slider");
var stepIcon_1 = require("./theme/components/stepIcon/stepIcon");
var stepLabel_1 = require("./theme/components/stepLabel/stepLabel");
var svgIcon_1 = require("./theme/components/svgIcon/svgIcon");
var switch_1 = require("./theme/components/switch/switch");
var tab_1 = require("./theme/components/tab/tab");
var tabs_1 = require("./theme/components/tabs/tabs");
var textField_1 = require("./theme/components/textField/textField");
var tooltip_1 = require("./theme/components/tooltip/tooltip");
// Props overrides
var accordionSummaryProps_1 = require("./theme/components/accordionSummary/accordionSummaryProps");
var alertProps_1 = require("./theme/components/alert/alertProps");
var BadgeProps_1 = require("./theme/components/Badge/BadgeProps");
var buttonProps_1 = require("./theme/components/button/buttonProps");
var containerProps_1 = require("./theme/components/container/containerProps");
var checkboxProps_1 = require("./theme/components/checkbox/checkboxProps");
var chipProps_1 = require("./theme/components/chip/chipProps");
var dialogContentProps_1 = require("./theme/components/DialogContent/dialogContentProps");
var floatingActionButtonProps_1 = require("./theme/components/floatingActionButton/floatingActionButtonProps");
var formHelperTextProps_1 = require("./theme/components/formHelperText/formHelperTextProps");
var iconButtonProps_1 = require("./theme/components/iconButton/iconButtonProps");
var inputLabelProps_1 = require("./theme/components/inputLabel/inputLabelProps");
var linkProps_1 = require("./theme/components/link/linkProps");
var menuProps_1 = require("./theme/components/menu/menuProps");
var paginationProps_1 = require("./theme/components/pagination/paginationProps");
var radioProps_1 = require("./theme/components/radio/radioProps");
var selectProps_1 = require("./theme/components/select/selectProps");
var sliderProps_1 = require("./theme/components/slider/sliderProps");
var stepIconProps_1 = require("./theme/components/stepIcon/stepIconProps");
var stepConnector_1 = require("./theme/components/stepConnector/stepConnector");
var switchProps_1 = require("./theme/components/switch/switchProps");
var tabsProps_1 = require("./theme/components/tabs/tabsProps");
var textFieldProps_1 = require("./theme/components/textField/textFieldProps");
var tdcTheme = (0, createTheme_1.default)({
    palette: palette_1.palette,
    typography: typography_1.typography,
    shape: shape_1.shape,
    breakpoints: breakpoints_1.breakpoints,
    overrides: __assign({ MuiAccordion: accordion_1.MuiAccordion, MuiAccordionDetails: accordionDetails_1.MuiAccordionDetails, MuiAccordionSummary: accordionSummary_1.MuiAccordionSummary, MuiAlert: alert_1.MuiAlert, MuiBackdrop: backdrop_1.MuiBackdrop, MuiBadge: Badge_1.MuiBadge, MuiBreadcrumbs: breadcrumbs_1.MuiBreadcrumbs, MuiButton: button_1.MuiButton, MuiCard: Card_1.MuiCard, MuiCardContent: CardContent_1.MuiCardContent, MuiCheckbox: checkbox_1.MuiCheckbox, MuiChip: chip_1.MuiChip, MuiCssBaseline: baseLine_1.MuiCssBaseline, MuiDialogTitle: dialogTitle_1.MuiDialogTitle, MuiDialogContent: dialogContent_1.MuiDialogContent, MuiDialogContentText: dialogContectText_1.MuiDialogContentText, MuiDialogActions: dialogActions_1.MuiDialogActions, MuiFab: floatingActionButton_1.MuiFab, MuiFormControl: formControl_1.MuiFormControl, MuiFormControlLabel: formControlLabel_1.MuiFormControlLabel, MuiFormHelperText: formHelperText_1.MuiFormHelperText, MuiFormLabel: formLabel_1.MuiFormLabel, MuiIconButton: iconButton_1.MuiIconButton, MuiInputBase: inputBase_1.MuiInputBase, MuiInputLabel: inputLabel_1.MuiInputLabel, MuiInputAdornment: inputAdornment_1.MuiInputAdornment, MuiLinearProgress: linearProgress_1.MuiLinearProgress, MuiLink: link_1.MuiLink, MuiListItem: listItem_1.MuiListItem, MuiMenu: menu_1.MuiMenu, MuiMenuItem: menuItem_1.MuiMenuItem, MuiMobileStepper: mobileStepper_1.MuiMobileStepper, MuiOutlinedInput: outlinedInput_1.MuiOutlinedInput, MuiPopover: popover_1.MuiPopover, MuiRadio: radio_1.MuiRadio, MuiSelect: select_1.MuiSelect, MuiSlider: slider_1.MuiSlider, MuiStepIcon: stepIcon_1.MuiStepIcon, MuiStepLabel: stepLabel_1.MuiStepLabel, MuiStepConnector: stepConnector_1.MuiStepConnector, MuiSvgIcon: svgIcon_1.MuiSvgIcon, MuiSwitch: switch_1.MuiSwitch, MuiTooltip: tooltip_1.MuiTooltip, MuiTab: tab_1.MuiTab, MuiTabs: tabs_1.MuiTabs, MuiTextField: textField_1.MuiTextField, MuiPaginationItem: paginationItem_1.MuiPaginationItem }, pickers_1.MuiPickers),
    props: {
        MuiAccordionSummary: accordionSummaryProps_1.MuiAccordionSummaryProps,
        MuiAlert: alertProps_1.MuiAlertProps,
        MuiBadge: BadgeProps_1.MuiBadgeProps,
        MuiButton: buttonProps_1.MuiButtonProps,
        MuiContainer: containerProps_1.MuiContainerProps,
        MuiCheckbox: checkboxProps_1.MuiCheckboxProps,
        MuiChip: chipProps_1.MuiChipProps,
        MuiDialogContentText: dialogContentProps_1.MuiDialogContentTextProps,
        MuiFab: floatingActionButtonProps_1.MuiFabProps,
        MuiFormHelperText: formHelperTextProps_1.MuiFormHelperTextProps,
        MuiIconButton: iconButtonProps_1.MuiIconButtonProps,
        MuiInputLabel: inputLabelProps_1.MuiInputLabelProps,
        MuiLink: linkProps_1.MuiLinkProps,
        MuiMenu: menuProps_1.MuiMenuProps,
        MuiRadio: radioProps_1.MuiRadioProps,
        MuiSelect: selectProps_1.MuiSelectProps,
        MuiSlider: sliderProps_1.MuiSliderProps,
        MuiStepIcon: stepIconProps_1.MuiStepIconProps,
        MuiSwitch: switchProps_1.MuiSwitchProps,
        MuiTabs: tabsProps_1.MuiTabsProps,
        MuiTextField: textFieldProps_1.MuiTextFieldProps,
        MuiPagination: paginationProps_1.MuiPaginationProps,
    },
});
var variants_1 = require("./theme/global/variants");
Object.defineProperty(exports, "Variants", { enumerable: true, get: function () { return variants_1.Variants; } });
exports.default = tdcTheme;
